import { useSnapshot } from 'valtio';

import { AuthState } from '../lib/types';
import { authState } from '../state';
import { useEffect } from 'react';
import AuthModule from '..';

let mockedAuth: AuthState | null = null;

export function setMockedAuth(auth: Partial<AuthState>) {
  mockedAuth = { ...authState, ...auth };
}

// when alwaysFresh is true, the token refresh check will occur every minute
function useAuth(alwaysFresh = false) {
  const auth = useSnapshot(authState);

  useEffect(() => {
    if (alwaysFresh) {
      const interval = setInterval(() => {
        AuthModule.getCurrentToken();
      }, 60_000);

      return () => clearInterval(interval);
    }
  }, [alwaysFresh]);

  if (mockedAuth) {
    return mockedAuth;
  }

  return auth;
}

export default useAuth;
